import { NewsCardComponentsModule } from 'src/app/components/news-card/news-card.components.module';
import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductAccountPageRoutingModule } from './product-account-routing.module';

import { ProductAccountPage } from './product-account.page';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralComponentsModule } from 'src/app/components/general/general.components.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    IonicModule,
    OfflineComponentsModule,
    GeneralComponentsModule,
    NewsCardComponentsModule,
    ProductAccountPageRoutingModule
  ],
  declarations: [ProductAccountPage]
})
export class ProductAccountPageModule {}
